// Dev: File cannot be changed. This is the Javascript entry point.

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ConfigProvider } from './ConfigContext';
import { Auth0Provider } from '@auth0/auth0-react';


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
const domain = process.env.REACT_APP_AUTH0_DOMAIN ?? "";
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID ?? "";
const requireAuth = process.env.REACT_APP_REQUIRE_AUTH === "true";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const app = (
  <React.StrictMode>
    <ConfigProvider>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
);

if (requireAuth && domain && clientId) {
  root.render(
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope: "openid profile email",
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {app}
    </Auth0Provider>
  );
} else {
  root.render(app);
}

reportWebVitals();